/**
 * Rocket Launcher RL-5 — safe post-login return paths.
 * Only same-app relative paths (block open redirects).
 */

export function isSafeAppRedirect (value) {
  if (value == null) return false
  const path = String(value).trim()
  if (!path.startsWith('/')) return false
  if (path.startsWith('//')) return false
  if (path.includes('://')) return false
  // Hash-mode apps sometimes pass "#/landing" — normalize
  if (path.startsWith('/#')) return false
  return true
}

/**
 * Prefer ?redirect= when present and safe; else fallback route name/path.
 */
export function resolvePostLoginTarget (query, fallbackPath) {
  const raw = query && (query.redirect || query.returnTo)
  if (isSafeAppRedirect(raw)) return String(raw).trim()
  return fallbackPath || '/landing'
}
